import { useEffect, useState } from "react";
import {  useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Header from "../../../../Layout/Header";

import CustomerCommonService from "../../../../services/customer_appCommonService";
import toast from "react-hot-toast";
import EmployeeLoginModal from "./EmployeeLoginModal";

const HbEmployee = () => {
  let appData = useSelector((state) => state?.app?.info); // appData from Store


  const [isCardVisible, setCardVisible] = useState(true);
  const [getEmployeeData, setEmployeeData] = useState([]);
  const [getLoginModal, setLoginModal] = useState(false);

  const columns = [
    {
      name: "Name of employee",
      selector: (row) => row.firstName,
      cell: (row) => (
        <div
          onClick={() => showLoginModal(row)}
          // onClick={() => handleNavigate(row.userId, "12345")}
          className="flex items-center gap-2 cursor-pointer"
        >
          <img
            src="assets/img/profile-img.png"
            alt="employeeImage"
            className="w-8 h-8 rounded-full"
          />
          <div>
            <div className="font-medium">{row.firstName}</div>
          </div>
        </div>
      ),
      width: "250px",
      sortable: true,
    },
    {
      name: "Email",
      cell: (row) => (
        <div className="flex items-center gap-2">
          <div>
            <div className="text-md fw-medium">{row.email}</div>
          </div>
        </div>
      ),
      width: "250px",
    },
    {
      name: "User ID",
      selector: (row) => row.userId,

      sortable: true,
      width: "160px",
    },
    {
      name: "Role",
      selector: (row) => row.category,
      cell: (row) => (
        <div className="flex items-center gap-2">
          <div>
            <div className="text-md fw-medium">{row?.roles[0]?.roleId}</div>
          </div>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    // {
    //   name: "Department",
    //   selector: (row) => row.department,
    //   sortable: true,
    //   width: "160px",
    // },
    // {
    //   name: "Join date",
    //   selector: (row) => row.joinDate,
    //   sortable: true,
    //   width: "160px",
    // },
    {
      name: "Status",
      cell: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-semibold ${
            row.userStatus === "Active"
              ? "bg-green-100 text-green-600"
              : row.status === "Inactive"
              ? "bg-red-100 text-red-600"
              : "bg-yellow-100 text-yellow-600"
          }`}
        >
          {row.userStatus}
        </span>
      ),
      width: "140px",
    },
  ];

  const [getUserId, setUserId] = useState({});
  const showLoginModal = (user) => {
    setLoginModal(true);
    setUserId(user);
  };
  const hideModal = () => {
    setLoginModal(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };



  useEffect(() => {
    if (!appData?.defaultAppCode) return;

    const fetchEmployeeList = async () => {
      try {
        const obj = {
          queryName: "Get_EMPLOYEE_LIST",
          category: appData.defaultAppCode,
          // category: "DESIGN",
        };

        const res = await CustomerCommonService.generateCustomerQueryV1(obj);

        if (res?.data?.length) {
          setEmployeeData(res.data);
        }
      } catch (error) {
        toast.error("Failed to fetch employee details!");
      }
    };

    fetchEmployeeList();
  }, [appData?.defaultAppCode]);

  return (
    <>
      <main className="dashboard main" id="">
        {/* <Layout /> */}
        <Header />
        <Row className="justify-center subContent">
          <Col xs={12} md={12} className="rightSide">
            <div className="rightSideInner PageCommonCSS">
              <Row>
                <Col xs={12} md={8} lg={8}>
                  <h2 className="mainTitle">Employee List</h2>
                  <p className="subText">Employee Directory and Overview </p>
                </Col>
                <Col xs={12} md={3} lg={3} className="mt-3">
                  {/* <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                /> */}
                </Col>
              </Row>
              <hr />

              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">CL</span>
                      </Col>
                      <Col xs={8} md={3} lg={3}>
                        <span className="headerTitle">EmployeeList</span>
                        <span className="subHeaderTitle">
                          View of Employee and Status{" "}
                        </span>
                      </Col>

                      <Col
                        xs={12}
                        md={7}
                        lg={7}
                        className="headerButtonAlign"
                      ></Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        {/* <StickyColumn
                        columnIndexes={[2, 3, 4]}
                        leftOffsets={[0, 120, 230]}
                      /> */}
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={columns}
                            data={getEmployeeData}
                            // progressPending={customerData?.status}
                            // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                            pagination
                            paginationServer
                            //   paginationTotalRows={customerTable.total}
                            //   onChangeRowsPerPage={handlePerRowsChange}
                            //   onChangePage={handlePageChange}
                            //   onSelectedRowsChange={handleRowSelect}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </main>
      <EmployeeLoginModal
        show={getLoginModal}
        onHide={() => hideModal()}
        user={getUserId}
        // dropdownData={getAccountGroup}
      />
    </>
  );
};

export default HbEmployee;
